export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 8_05.45d9ec79.jpg";